module.exports = __webpack_public_path__ + "static/media/thaphoctap2019.71eb938a.png";